import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"

export const getStatementsOfAccount = async (payload) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "statement_of_account/get_all_statement_of_account",
      {
        requester: getUser(),
        token: getToken(),
        ...payload,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getStatementOfAccount = async (payload) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "statement_of_account/get_statement_of_account",
      {
        requester: getUser(),
        token: getToken(),
        ...payload,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateInvoiceDescription = async (project_invoice_id, description) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "statement_of_account/update_invoice_description",
      {
        requester: getUser(),
        token: getToken(),
        project_invoice_id,
        description,
      }
    )
    return { data: response.data, status: response.status }
  } catch (error) {
    return { error: error }
  }
}

export const updatePaymentDescription = async (project_invoice_payment_id, description) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "statement_of_account/update_payment_description",
      {
        requester: getUser(),
        token: getToken(),
        project_invoice_payment_id,
        description,
      }
    )
    return { data: response.data, status: response.status }
  } catch (error) {
    return { error: error }
  }
}